import React from "react";

function Select({ value, onChange, options = [] }) {
  return (
    <select className="soft-input" value={value} onChange={onChange}>
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
}

export default Select;
